import { ServiceOption } from '../../../../../generated/ApiClient';

/**
 * The technical-option ids required by the currently-selected product options.
 *
 * ApiCon marks some vehicle technical options (e.g. truck_#CTP, truck_J4O) as required by a product
 * option via its `requires` list. The backend surfaces those ids on each product option's
 * `requiredTechnicalOptionIds`. This unions them across the selected product options so the UI can
 * mark the matching technical options as required and block the price request until they are selected.
 */
export const getRequiredTechnicalOptionIds = (
  productOptions: ServiceOption[],
  selectedProductOptionIds: readonly string[]
): string[] => {
  const selected = new Set(selectedProductOptionIds);
  const required = new Set<string>();

  for (const option of productOptions) {
    if (option.id == null || !selected.has(option.id)) continue;
    for (const requiredId of option.requiredTechnicalOptionIds ?? []) {
      required.add(requiredId);
    }
  }

  return Array.from(required);
};

/** Required technical options that are not yet selected. */
export const getMissingRequiredTechnicalOptionIds = (
  productOptions: ServiceOption[],
  selectedProductOptionIds: readonly string[],
  selectedTechnicalOptionIds: readonly string[]
): string[] => {
  const selectedTechnical = new Set(selectedTechnicalOptionIds);
  return getRequiredTechnicalOptionIds(productOptions, selectedProductOptionIds).filter(
    (id) => !selectedTechnical.has(id)
  );
};
